/**
*
* Datepicker Wrapper
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import theme from '../../theme';

const DateWrapper = styled.div`
  .react-datepicker{
  &.booking_calendar{
    border: none;
    padding: 10px;
    background-color: ${theme.lightWhite};
    border-radius:0;
    .react-datepicker__triangle, .react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before{
      border-bottom-color: ${theme.lightWhite} !important;
    }
    .react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before{
      border-bottom-color: ${theme.secondaryColor};
    }
    .react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range{
      color: ${theme.whiteColor};
      border-radius:0px;
      font-weight:bold;
      background:${theme.primaryColor} !important;
    }
    .react-datepicker__day{
      background:${theme.whiteColor};
      margin:0px;
      border:${theme.lightGray} solid 1px;
      width: 2.7rem;
      line-height: 2.7rem;
    }
    .react-datepicker__day-name{
      width: 2.4rem;
      line-height: 2.7rem;
    }
    .react-datepicker__day--keyboard-selected{
      border-radius:0;
      color:${theme.secondaryColor};
      font-weight:bold;
      outline: 4px solid ${theme.primaryColor};
      outline-offset: -4px;
    }                                       
    .react-datepicker__month{
      margin:0.4rem 0px
    }
    .react-datepicker__header{
      background-color:${theme.transparentColor};
    }
    .react-datepicker__day--outside-month{
      background-color:${theme.lightWhite};
      color:${theme.lightGray};
    }
  }
}
`;

const _handleChange = (handleChange, evt, key) => {
  handleChange(key, evt);
};
const onChangeRaw = (e) => {
  e.preventDefault();
};

function DatepickerWrapper(props) {
  const { handleChange, payloadKey } = props;
  return (
    <DateWrapper>
      <DatePicker
        {...props}
        onChange={(e) => _handleChange(handleChange, e, payloadKey)}
        onChangeRaw={(e) => onChangeRaw(e)}
      />
    </DateWrapper>
  );
}

DatepickerWrapper.propTypes = {
  handleChange: PropTypes.func,
  payloadKey: PropTypes.string,
};

DatepickerWrapper.defaultProps = {
  // selected: '',
};

export default DatepickerWrapper;



// WEBPACK FOOTER //
// client/components/DatepickerWrapper/index.js